import { render, staticRenderFns } from "./KeywordSuggestionAddForm.vue?vue&type=template&id=45a241c9"
import script from "./KeywordSuggestionAddForm.vue?vue&type=script&lang=js"
export * from "./KeywordSuggestionAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports